import React from "react";
import { splitMeridiem } from "../../utils/time";

const PrayerCard = ({ name, adhan, iqamah, isNext, colorSettings = {} }) => {
  const {
    bodyBackgroundColor = "#096D6D",
    bodyTextColor = "#ffffff",
    bodyTimingColor = "#ffffff",
    highlightColor = "#D39B51",
  } = colorSettings;

  const cardBackground = isNext ? highlightColor : bodyBackgroundColor;
  const textColor = isNext ? "#000000" : bodyTextColor;
  const timingColor = isNext ? "#000000" : bodyTimingColor;

  const adhanParts = splitMeridiem(adhan);
  const iqamahParts = splitMeridiem(iqamah);

  return (
    <div
      className="w-full sm:w-full xl:w-2/12 py-[1.3svh] leading-[1.3] font-sans"
      style={{ backgroundColor: cardBackground }}
    >
      {/* Adhan */}
      <p className="text-[3.8svh] my-[0.4svh]" style={{ color: timingColor }}>
        {adhanParts ? (
          <>
            <span>{adhanParts.main}</span>
            <span className="text-[2.4svh] ml-[0.2svh]">{adhanParts.mer}</span>
          </>
        ) : (
          // Fallback: keep your previous leading-zero trim if not 12h
          (adhan || "—").replace(/^0(\d):/, "$1:")
        )}
      </p>

      {/* Name */}
      <h4 className="text-[2.3svh] tracking-[0.8svh] font-normal" style={{ color: textColor }}>
        {name}
      </h4>

      {/* Iqamah */}
      <p className="text-[4.8svh] my-[0.4svh]" style={{ color: timingColor }}>
        {iqamahParts ? (
          <>
            <span>{iqamahParts.main}</span>
            <span className="text-[3svh] ml-[0.2svh]">{iqamahParts.mer}</span>
          </>
        ) : (
          (iqamah || "—").replace(/^0(\d):/, "$1:")
        )}
      </p>
    </div>
  );
};

export default PrayerCard;